import React, { FC } from "react";

import { EditableSection } from "@/components/EditableSection";
import { Section } from "@/components/Section";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { GeneralSection } from "./GeneralSection";

interface IEditableGeneralSectionProps {
  record: IConsultantProfile;
  onUpdate?: (profile: IConsultantProfile) => void;
  trackClick?: (sectionName: string) => void;
  afterUpdate?: () => void;
}

export const EditableGeneralSection: FC<IEditableGeneralSectionProps> = ({
  record,
  onUpdate,
  trackClick,
  afterUpdate,
}) => {
  return (
    <Section borderRadius padding={["lg"]}>
      <EditableSection direction="column" onEditClick={() => trackClick?.("Personal Data")}>
        {editableProps => (
          <GeneralSection editableProps={editableProps} record={record} onUpdate={onUpdate} afterUpdate={afterUpdate} />
        )}
      </EditableSection>
    </Section>
  );
};
